import React, { useState, useEffect } from 'react';
import AdminNav from './AdminNav';
import '../styles/GlobalDesign.css';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Gérer le state de la sidebar depuis le localStorage
  useEffect(() => {
    const saved = localStorage.getItem('sidebarOpen');
    if (saved !== null) {
      setSidebarOpen(JSON.parse(saved));
    }
  }, []);

  // Partager le state de la sidebar avec AdminNav via Context ou props
  useEffect(() => {
    const handleSidebarToggle = (e) => {
      setSidebarOpen(e.detail.open);
      localStorage.setItem('sidebarOpen', JSON.stringify(e.detail.open));
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle);
    return () => window.removeEventListener('sidebarToggle', handleSidebarToggle);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'} ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      {/* Bouton hamburger mobile */}
      <button 
        className={`mobile-menu-toggle admin-toggle ${mobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Ouvrir le menu admin"
        aria-expanded={mobileMenuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Overlay pour mobile */}
      {mobileMenuOpen && (
        <div className="sidebar-overlay" onClick={closeMobileMenu}></div>
      )}

      <AdminNav mobileOpen={mobileMenuOpen} />
      <div className={`admin-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
